var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChild)?_c('span',{staticClass:"badge badge-soft-success font-size-11"},[_vm._v(" Sí ")]):_c('span',{staticClass:"badge badge-soft-danger font-size-11"},[_vm._v(" No ")])
}
var staticRenderFns = []

export { render, staticRenderFns }